// EdgeTypes.js
import React from "react";
import CustomEdge from "./CustomEdge";

const withDslJson = (Component, dslJson) => (props) => <Component {...props} dslJson={dslJson} />;

export const getEdgeTypes = (dslJson) => ({
	customEdge: withDslJson(CustomEdge, dslJson),
});
